import apiClient from "./axios"

export const getMonthlyKpiSummary = async (params = {}) => {
  const { data } = await apiClient.get("/kpi/report/monthly", { params })
  return data
}

export const getAttendanceLeaderboard = async (params = {}) => {
  const { data } = await apiClient.get("/kpi/attendance-leaderboard", { params })
  return data
}

export const getEmployeeKpiBreakdown = async (employeeId, params = {}) => {
  const { data } = await apiClient.get(`/kpi/employees/${employeeId}/breakdown`, { params })
  return data
}

export const getMyKpiReport = async (params = {}) => {
  const { data } = await apiClient.get("/kpi/my-report", { params })
  return data
}

export const getKpiMetricDefinitions = async () => {
  const { data } = await apiClient.get("/kpi/metric-definitions")
  return data
}

export const updateKpiMetricDefinition = async (id, payload) => {
  const { data } = await apiClient.put(`/kpi/metric-definitions/${id}`, payload)
  return data
}
